import React from 'react';
import { Box, Stack, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import EventCalendar from '../meeting/EventCalender';

interface ManualSchedulingFormProps {
  start: dayjs.Dayjs;
  end: dayjs.Dayjs;
  duration: number;
  mode: 'create' | 'edit' | 'upload';
  onStartChange: (val: dayjs.Dayjs | null) => void;
  onDurationChange: (e: SelectChangeEvent<number>) => void;
  onCalendarSelect: (date: Date) => void;
  onCalendarNavigate: (action: string, view: string, currentDate: Date) => void;
}

const ManualSchedulingForm: React.FC<ManualSchedulingFormProps> = ({
  start,
  end,
  duration,
  mode,
  onStartChange,
  onDurationChange,
  onCalendarSelect,
  onCalendarNavigate,
}) => (
  <>
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack direction="row" spacing={2}>
          <DateTimePicker
            label="Start Time"
            value={start}
            onChange={onStartChange}
            format="DD/MM/YYYY | hh:mm A"
            slotProps={{ textField: { placeholder: 'DD/MM/YYYY | hh:mm', size: 'small' } }}
            sx={{ flex: 1 }}
          />
          <FormControl sx={{ flex: 1 }} size="small">
            <InputLabel>Duration</InputLabel>
            <Select size="small" value={duration} label="Duration" onChange={onDurationChange}>
              {[15, 30, 45, 60, 90, 120].map((min) => (
                <MenuItem key={min} value={min}>{min} min</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </LocalizationProvider>
    </Box>
    <EventCalendar
      date={start}
      onSelectDate={onCalendarSelect}
      onNavigate={onCalendarNavigate}
      step={mode !== 'edit' ? duration : end.diff(start, 'minute')}
    />
  </>
);

export default ManualSchedulingForm;
